// Author: Sunil Jain
// Timestamp: 2025-04-12 10:28:55 AM EDT
// File: src/theme.js

import { createTheme } from '@mui/material/styles';

// NOTE: This theme is copied directly from v4fe-up/src/theme.js
// to maintain visual consistency between patient and physician portals.
const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3', // A vibrant, yet professional blue (Material UI's default blue)
      light: '#64b5f6', // Lighter shade of primary
      dark: '#1565c0',  // Darker shade of primary for hover, etc.
      contrastText: '#fff', // White text on primary color
    },
    secondary: {
      main: '#90a4ae', // Muted grayish-blue as a secondary/accent color.
      light: '#c1d5e0',
      dark: '#62757f',
      contrastText: '#000', // Black text on secondary color
    },
    success:{
      main: '#4caf50' //Use for success or valid messages.
    },
    error: {
      main: '#f44336', // Standard red for errors
    },
    warning: {
      main: '#ff9800', // Standard orange for warnings
    },
    info: {
        main: '#2196f3' //Informative message.
    },
    background: {
      default: '#f5f5f5', // Very light gray background
      paper: '#ffffff',     // White for cards, forms
    },
    text: {
      primary: '#212121',  // Almost black for main text
      secondary: '#757575', // Medium gray for secondary text
      disabled: '#bdbdbd', // Lighter gray for disabled text
    },
    divider: 'rgba(0, 0, 0, 0.12)', // Light gray for dividers
  },
  typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: '2.5rem',
            fontWeight: 500,
            marginBottom: '1rem',
            color: '#212121' // Use text.primary color
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 500,
            marginBottom: '0.8rem',
            color: '#212121'
        },
    // ... other typography styles ...
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiTextField: {
        styleOverrides: {
            root: {
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: 'rgba(0, 0, 0, 0.23)', // Default Material UI border
                    },
                    '&:hover fieldset': {
                        borderColor: '#2196f3', // Primary color on hover
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#2196f3', // Primary color when focused
                    },
                },
            },
        },
    },
    MuiInputLabel:{ //Change Input Labels also.
          styleOverrides:{
            root:{
                '&.Mui-focused': {
                    color: '#2196f3', // Green when focused
                },
            }
          }
    },
    MuiCheckbox:{  //Checkbox change
       styleOverrides: {
            root: {
              color: 'rgba(0, 0, 0, 0.23)', // Default color
                '&.Mui-checked': {
                  color: '#2196f3', // Color when checked
                },
            }
       }
    },
      MuiSelect: { //Select dropdown
        styleOverrides:{
            root:{
                '& .MuiOutlinedInput-notchedOutline': {
                     borderColor: 'rgba(0, 0, 0, 0.23) !important',
                },
            }
        }
    },
     MuiIconButton: {
        styleOverrides: {
            root:{
              color: "#212121" //Change Icon Color
            }
        }
    },
     MuiFormControlLabel: { //For required label
        styleOverrides: {
            asterisk: {
                color: '#f44336',
            }
        }
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2196f3', // Use primary color
          color: '#fff',           // Use contrastText for good contrast
        },
      },
    },
    MuiDrawer: { // Style the Drawer
        styleOverrides: {
          paper: {
            backgroundColor: '#f5f5f5',
            color: '#212121'

          }
        }
    },
    MuiListItemButton: { //Style List Item Button
        styleOverrides: {
            root:{
                "&.Mui-selected": {
                    backgroundColor: "#2196f3", //Change to primary color
                    color: "#fff", //change text color
                    "& .MuiListItemIcon-root": { //target ListItemIcon inside a selected ListItemButton,
                      color: "#fff" // change icon color.
                    }
                  },
                "&.Mui-selected:hover": {
                    backgroundColor: "#1565c0" //Change to dark primary color on hover
                }
            }
        }
    },
     MuiListItemIcon: { //Style List Item icons
        styleOverrides: {
            root:{
                 color: "#212121" //Change Icon Color
            }
        }
     }
  },
});

export default theme;